var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.button.class,attrs:{"type":"button"},domProps:{"textContent":_vm._s(_vm.button.text)},on:{"click":_vm.clicked}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e17fcbae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Faqs/Utilities/Buttons/Contact.vue
// module id = 704
// module chunks = 0 1